
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.496 14.183c-1.855 0-3.359-1.517-3.359-3.388s1.504-3.388 3.36-3.388c1.854 0 3.358 1.517 3.358 3.388s-1.504 3.388-3.359 3.388m.72-9.555c-4.74 0-6.693 3.49-6.693 6.167 0 3.327 2.674 6.025 5.973 6.025 3.3 0 5.974-2.698 5.974-6.025a6.036 6.036 0 00-.852-3.101c2.774.817 5.518 3.038 6.17 3.712-1.817 4.196-5.982 6.96-11.27 6.96-5.29 0-9.504-2.777-11.767-7.435 1.791-4.772 6.623-8.292 12.465-8.292 3.956 0 8.548 1.304 12.136 4.099.454-1.55.44-2.966.44-2.966S22.49 0 15.218 0C6.785 0 1.469 5.77 0 10.931 1.697 15.984 6.858 21 14.499 21c7.64 0 12.769-5.016 14.501-10.069-3.288-3.678-8.375-6.303-13.784-6.303"}})])
          )
        }
      }
    